import VueSignature from './components/vueSignature.vue'
export default VueSignature